import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'

class InstanciaCalado extends Component {
  render () {
    const {
      cpa
    } = this.props

    let estadoCalificacion
    if (cpa.estadoCalificacion) {
      if (cpa.estadoCalificacion === 'A') {
        estadoCalificacion = 'Conforme'
      } else if (cpa.estadoCalificacion === 'C') {
        estadoCalificacion = 'Condicional'
      }
    }

    return (
      <div className='cantidad-camiones-circuito'>
        <h6 className='texto-info'>Proceso de calado realizado. </h6>
        <div className='info-calificacion-consulta-chofer'>
          <h6 className='texto-info'>Estado de calificación: <strong>{estadoCalificacion}</strong></h6>
          {cpa.nombreCalificacionCereal && <h6 style={{ margin: '2% auto' }} className='texto-info'>{cpa.nombreCalificacionCereal}</h6> }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  cerealVolcadoras: state.volcadora.cerealVolcadoras,
  detalle: state.entregadores.detalle,
  totalCamiones: state.camionesIngreso.totalCamionesCereal,
  turnosPendientes: state.camionesIngreso.turnosPendientesPlaya,
  pedidoCamiones: state.camionesIngreso.camionesPedidos
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(InstanciaCalado)
